const stats = [
  { value: 'Always', label: 'Live chat access' },
  { value: '10k+', label: 'Trees guided to safety' },
  { value: 'Win + Mac', label: 'Both platforms covered' },
  { value: 'Cloud', label: 'TreeVault specialists' },
];

export default function StatsBar() {
  return (
    <section className="t7-stats">
      <div className="container">
        <div className="t7-stats__grid">
          {stats.map((stat) => (
            <div key={stat.label} className="t7-stats__item">
              <p className="t7-stats__value">{stat.value}</p>
              <p className="t7-stats__label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
